import React from 'react';
import API from '../../services/api.jsx'
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Table from '../layout/table.jsx'
import Loader from '../layout/loader.jsx'
import moment from 'moment'
import { toast } from 'react-toastify'
import { debounce } from 'lodash'
import Helpers from '../../services/helpers.jsx'
import User from '../../services/user.jsx'

const userPermissions = User.permissions();

class ClientList extends React.Component {
	constructor(props) {
		super(props)

		const actions = [];
		if (Helpers.checkPermissions('clients:edit')) {
			actions.push({
				classList: 'blue add',
				label: 'New client',
				onClick: () => {
					this.props.history.push('/clients/new')
				}
			});
		}

		this.state = {
      loading: true,
      filters: {},
      sort: ['createdAt', 'DESC'],
      clients: {
        columns: [
          {
            label: 'Name',
            key: 'name',
            canSort: true,
            width: '30%',
            onSortClick: (column) => this.onSort(column.key),
          },
          {
            label: 'Assigned affiliate(s)',
            key: 'affiliates',
            view: (field) => {
              if (Array.isArray(field)) {
                if (field.length === 0) {
                  return 'All';
                } else {
                  return field?.map((affiliate) => affiliate.name)?.join(', ');
                }
              } else {
                return '-';
              }
            },
          },
          {
            label: 'Devices',
            key: 'deviceCount',
            canSort: true,
            onSortClick: (column) => this.onSort(column.key),
          },
          {
            label: 'Creation date',
            key: 'createdAt',
            canSort: true,
            view: function (field) {
              return moment(field).format('l');
            },
            onSortClick: (column) => this.onSort(column.key),
          },
          {
            action: 'delete',
            hidden: !Helpers.checkPermissions('clients:delete'),
            onClick: (id, key) => {
              var r = window.confirm(
                'Are you sure you want to delete this client?'
              );
              if (r === false) return;

              this.setState({ loading: true });
              API.delete('clients', id)
                .then(() => {
                  toast.success('Client was successfully deleted');
                  this.loadEntities();
                })
                .catch(() => {
                  // toast.success('An unexpected error has occurred')
                  this.setState({ loading: false });
                });
            },
          },
        ],
        entities: [],
        filters: [
          {
            label: 'Search a client',
            onChange: debounce((value) => {
              if (value !== this.state.filters.name)
                this.setState(
                  {
                    filters: {
                      ...this.state.filters,
                      name: value ? '/' + value + '/i' : '',
                    },
                  },
                  () => {
                    this.loadEntities();
                  }
                );
            }, 500),
          },
        ],
        actions,
        selectedItems: [],
        multiSelect: false,
        onRowClick: (entity) => {
          const subTabs = [
            'clients:subtab:campaigns',
            'clients:subtab:devices',
            'clients:subtab:playlists',
            'clients:subtab:collections',
          ];
          if (Helpers.checkPermissions(subTabs, true)) {
            const subTab = userPermissions?.permissions.find((permission) =>
              subTabs.includes(permission)
            );
            this.props.history.push(
              `/clients/${entity.id}/${subTab.split(':')[2]}`
            );
          }
        },
      },
    };
	}

	componentDidMount() {
		this.loadEntities()
	}

	onSort(key){
		const newSort = this.state?.sort?.[0] === key ? 
		this.state?.sort?.[1] === "ASC" ? [key, 'DESC'] : [key, 'ASC'] 
		: [key, 'ASC'];
		this.setState({
			sort: newSort
		}, () => {
			this.loadEntities()
		})
	}

	loadEntities() {
		API.getClients(this.state.filters, this.state.sort)
			.then(entities => {
				const filters = [];
				if (entities?.filters?.availableFilters) {
					Helpers.handleFilters(this, filters, entities);
				}

				this.setState({
					...this.state,
					loading: false,
					clients: {
						...this.state.clients,
          	filters,
						entities: entities?.data || []
					}
				})
			})
	}

	viewClient(id) {
		this.props.history.push('/clients/' + id + '/campaigns');
	}

	render() {
		if(this.state.loading)
			return <Loader />
		return <>
			<Head title={'Clients'} />
			<Content>
				<Table settings={this.state.clients} sort={this.state.sort}/>				
			</Content>
		</>
	}
}

export default ClientList;
